/**
 * Keeps the hidden `_lead_time` line item property in sync with the selected variant.
 *
 * The product info blocks Athora refreshes after a variant change are hard-coded in
 * `global.js` (`update_product_info_fn`), and the buy buttons block is not one of them.
 * So the input rendered by `snippets/lead-time-property.liquid` has to be re-read from
 * the section markup that the variant picker already fetched — it arrives on the
 * `variant-change` event as `detail.html`.
 *
 * That markup is rendered with `view=hdt_ajax`, where the buy buttons block skips its
 * whole form. `blocks/_buy-buttons.liquid` therefore emits the property on its own in
 * that view; without it every variant switch would look like "this variant has no lead
 * time" and silently drop the property.
 *
 * Loaded as a module from `blocks/_buy-buttons.liquid`; module scripts with the same URL
 * are evaluated once per document, so the quick view rendering the block a second time
 * does not register the listener twice.
 *
 * Documented in `materials/altdecor-docs/lead-time-property.md`.
 */

const PROPERTY_SELECTOR = 'input[data-lead-time-property]';

const syncLeadTimeProperty = (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;

  const { sectionId, html } = event.detail || {};
  if (!html) return;

  const fragment = document.createRange().createContextualFragment(html);
  const section = fragment.querySelector(`#shopify-section-${sectionId}`) || fragment;
  const source = section.querySelector(PROPERTY_SELECTOR);
  const current = form.querySelector(PROPERTY_SELECTOR);

  // The new variant carries no lead time — drop the property rather than ship a stale one.
  if (!source) {
    current?.remove();
    return;
  }

  if (current) {
    current.value = source.value;
    return;
  }

  form.append(source.cloneNode(true));
};

document.addEventListener('variant-change', syncLeadTimeProperty);
